/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCampaignFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCampaign, serializeSetCampaignActiveRequest, type Campaign, type ErrorResponse, type InternalErrorResponse, type SetCampaignActiveRequest } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/active
 */
export interface ActiveRequestBuilder extends BaseRequestBuilder<ActiveRequestBuilder> {
    /**
     * Deactivating stops new application and makes checkout reject a cart still holding one of the campaign's promotions, with the reason; its codes stop unlocking anything. Carts re-evaluate on their next change. Reactivating reverses it.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Campaign>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: SetCampaignActiveRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Campaign | undefined>;
    /**
     * Deactivating stops new application and makes checkout reject a cart still holding one of the campaign's promotions, with the reason; its codes stop unlocking anything. Carts re-evaluate on their next change. Reactivating reverses it.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SetCampaignActiveRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ActiveRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/active";
/**
 * Metadata for all the requests in the request builder.
 */
export const ActiveRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ActiveRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCampaignFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetCampaignActiveRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
